'use strict';

import React from 'react'

import Loader from '@Pure/Loader'

import Modal  from '@Modal/Modal'

export default class ExportedProvidersOrdersModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			status_messages: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.open        = this.open.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'open__ExportedProvidersOrdersModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'open__ExportedProvidersOrdersModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open (params)
	{
		const component = this, props = this.props;

		component.setState(
		{
			open : true,

			url: params.url
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let output =
		(
			<Modal open={ component.state.open } onClose={ component.handleClose }
				title="Export des commandes" hide_close={ true }>

				<div className="u-full-width u-center">
					<a className="c-btn c-btn--extra" href={ state.url }
						target="_blank" type="application/pdf">
						Télécharger le fichier
					</a>
				</div>

				<div className="c-dialog__buttons">
					<button className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Fermer
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
